module.exports = __webpack_public_path__ + "static/media/ashlyeHokanson.064df423.jpg";